<template>
  <form
    @submit.prevent="validateForm"
    :action="banorteValidatorPath"
    ref="form"
    method="POST"
  >
    <input type="hidden" :value="cardNumber" name="CARD_NUMBER">
    <input type="hidden" :value="cardExpirationDate" name="CARD_EXP">
    <input type="hidden" :value="saleOrderTotal" name="AMOUNT">
    <input type="hidden" :value="cardBrand" name="CARD_TYPE">
    <input type="hidden" :value="forwardPath" name="FORWARD_PATH">
    <input type="hidden" :value="saleOrderReference3D" name="REFERENCE3D">
    <input type="hidden" :value="creditType" name="CREDIT_TYPE">
    <input type="hidden" :value="cardHolderEmail" name="EMAIL">
    <input type="hidden" :value="cardHolderCity" name="CITY">
    <input type="hidden" :value="cardHolderFirstName" name="NAME">
    <input type="hidden" :value="cardHolderLastName" name="LAST_NAME">
    <input type="hidden" :value="cardHolderZipCode" name="POSTAL_CODE">
    <input type="hidden" :value="cardHolderState" name="STATE">
    <input type="hidden" :value="cardHolderCountry" name="COUNTRY">
    <input type="hidden" :value="cardHolderStreet" name="STREET">
    <input type="hidden" :value="cardHolderPhone" name="MOBILE_PHONE">
    <input type="hidden" value="8489112" name="MERCHANT_ID">
    <input type="hidden" value="PUENTE ZARAGOZA" name="MERCHANT_NAME">
    <input type="hidden" value="Juarez" name="MERCHANT_CITY">
    <input type="hidden" value="03" name="3D_CERTIFICATION">
    <input type="hidden" value="2" name="THREED_VERSION">
    <div class="form-group flex">
      <p>Estimado usuario, el Fideicomiso de Puentes Fronterizos de Chihuahua no almacena la información solicitada en este formulario, nuestro Banco utiliza estos datos para validar y asegurar su transacción.<br/>
      <b>Aceptamos solamente su tarjeta VISA o Master Card </b> <br/>
      <b>Su recarga no generará comisiones.</b></p>
    </div>
    <div class="form-group flex justify-space-between">
      <label for="card">TAG</label>
      <input :data-valid="loadedAndCorrect === true" :data-invalid="loadedAndWrong === true" v-model="tag" type="text" maxlength="14" :disabled="balanceIsLoading" placeholder="Introduce la clave de tu TAG">
    </div>
    <div class="errors" v-if="errors.tag">
      {{ errors.tag.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between" v-if="loadedAndCorrect === true">
      <label>Su saldo actual es de: </label>
      <label>{{ formattedBalance }}</label>
    </div>
    <div class="form-group flex justify-space-between">
      <label for="number">Cantidad que desea recargar</label>
      <input
        type="number"
        v-model="amount"
      />
    </div>
    <div class="errors" v-if="errors.amount">
      {{ errors.amount.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>Tipo de Tarjeta</label>
      <div class="form-group flex justify-space-between rad">
        <input
          type="radio"
          :value="0"
          v-model="cardType"
        />
        <label for="debit">Débito</label>
      </div>
      <div class="form-group flex justify-space-between rad">
        <input
          type="radio"
          :value="1"
          v-model="cardType"
        />
        <label for="credit">Crédito</label>
      </div>
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderFirstName">Nombre del titular</label>
      <input v-model="cardHolderFirstName" type="text" maxlength="60" autocomplete="off" placeholder="Nombre">
    </div>
    <div class="errors" v-if="errors.cardHolderFirstName">
      {{ errors.cardHolderFirstName.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderLastName">Apellidos</label>
      <input v-model="cardHolderLastName" type="text" maxlength="60" autocomplete="off" placeholder="Apellidos">
    </div>
    <div class="errors" v-if="errors.cardHolderLastName">
      {{ errors.cardHolderLastName.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderEmail">Correo electrónico</label>
      <input v-model="cardHolderEmail" type="text" maxlength="255" autocomplete="off" placeholder="Correo electrónico">
    </div>
    <div class="errors" v-if="errors.cardHolderEmail">
      {{ errors.cardHolderEmail.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderPhone">Número de celular</label>
      <input v-model="cardHolderPhone" type="text" maxlength="25" autocomplete="off" placeholder="Número celular">
    </div>
    <div class="errors" v-if="errors.cardHolderPhone">
      {{ errors.cardHolderPhone.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderStreet">Calle</label>
      <input v-model="cardHolderStreet" type="text" maxlength="60" autocomplete="off" placeholder="Calle">
    </div>
    <div class="errors" v-if="errors.cardHolderStreet">
      {{ errors.cardHolderStreet.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderCity">Ciudad</label>
      <input v-model="cardHolderCity" type="text" maxlength="50" autocomplete="off" placeholder="Ciudad">
    </div>
    <div class="errors" v-if="errors.cardHolderCity">
      {{ errors.cardHolderCity.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderZipCode">Código postal</label>
      <input v-model="cardHolderZipCode" type="text" maxlength="10" autocomplete="off" placeholder="Código postal">
    </div>
    <div class="errors" v-if="errors.cardHolderZipCode">
      {{ errors.cardHolderZipCode.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>País</label>
      <select v-model="cardHolderCountry">
        <option value="" disabled>Seleccione el país</option>
        <option
          v-for="country in [{id: 'MX', name: 'México'}, {id: 'US', name: 'United States'}]"
          :key="country.id"
          :value="country.id"
        >
          {{ country.name }}
        </option>
      </select>
    </div>
    <div class="errors" v-if="errors.cardHolderCountry">
      {{ errors.cardHolderCountry.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>Estado</label>
      <select v-model="cardHolderState">
        <option value="" disabled>Seleccione el estado</option>
        <option
          v-for="state in statesList"
          :key="state.id"
          :value="state.id"
        >
          {{ state.value }}
        </option>
      </select>
    </div>
    <div class="errors" v-if="errors.cardHolderState">
      {{ errors.cardHolderState.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="number">Número de tarjeta (VISA o MasterCard)</label>
      <input v-model="cardNumber" type="text" maxlength="16" placeholder="Número de la Tarjeta Crédito/Débito">
    </div>
    <div class="errors" v-if="errors.cardNumber">
      {{ errors.cardNumber.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="exp">Fecha de expiración</label>
      <div class="form-group flex justify-space-between fake-input">
        <select
          v-model="cardExpirationMonth"
          class="short-input"
        >
          <option value="" selected disabled>Mes</option>
          <option
            v-for="month in availableCardExpirationMonths"
            :key="month"
          >
            {{ month }}
          </option>
        </select>
        <span>/</span>
        <select
          v-model="cardExpirationYear"
          class="short-input"
        >
          <option value="" selected disabled>Año</option>
          <option
            v-for="year in availableCardExpirationYears"
            :key="year"
          >
            {{ year }}
          </option>
        </select>
      </div>
    </div>
    <div class="errors" v-if="errors.cardExpirationDate">
      {{ errors.cardExpirationDate.join(' - ') }}
    </div>
    <div v-if="formattedAmount" class="flex justify-space-between">
      <p>Monto</p>
      <p>{{ formattedAmount }}</p>
    </div>
    <div v-if="formattedCommissionPrice" class="flex justify-space-between">
      <p>Comisión</p>
      <p>{{ formattedCommissionPrice }}</p>
    </div>
    <div v-if="formattedTotal" class="flex justify-space-between">
      <p>Monto total</p>
      <p>{{ formattedTotal }}</p>
    </div>
    <div v-if="formattedNewBalance" class="flex justify-space-between">
      <p class="summary">Nuevo balance después de la recarga</p>
      <p>{{ formattedNewBalance }}</p>
    </div>
    <InformationModal @confirm="closeInformationModal" title="Atención" :active="isInformationModalActive">
      <template slot="content">
        <p>
          A continuación te enviaremos al sitio web de Banorte en donde validaremos tu tarjeta utilizando los datos que acabas
          de introducir, recuerda que debes conocer el método de validación usado por tu banco (SMS, correo electrónico, App Móvil).
          Una vez que validemos tu tarjeta, volverás automáticamente a este sitio para finalmente completar tu compra. Si tienes
          dudas sobre el proceso de validación <strong>3D Secure</strong>, contacta a tu banco.
        </p>
      </template>
    </InformationModal>
    <div class="flex justify-space-evenly-sm">
      <button type="submit" class="btn" :disabled="dataReady == false">Aceptar</button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InformationModal from '@/components/InformationModal'

export default {
  name: 'GuestTagForm',
  components: {
    InformationModal
  },
  data () {
    return {
      isInformationModalActive: false,
      errors: {}
    }
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('guestCreatedSaleOrder', [
      'saleOrderId',
      'saleOrderReference3D',
      'saleOrderTotal'
    ]),
    ...mapGetters('rechargeTagForm', [
      'cardBrand',
      'cardExpirationDate',
      'formattedAmount',
      'formattedCommissionPrice',
      'formattedNewBalance',
      'formattedBalance',
      'formattedTotal',
      'creditType',
      'cardHolderName',
      'tagNotFound',
      'balanceIsLoading',
      'loadedAndCorrect',
      'loadedAndWrong'
    ]),
    tag: {
      get () { return this.$store.state.rechargeTagForm.tag },
      set (value) { this.updateTag(value) }
    },
    amount: {
      get () { return this.$store.state.rechargeTagForm.amount },
      set (value) { this.updateAmount(value) }
    },
    cardExpirationMonth: {
      get () { return this.$store.state.rechargeTagForm.cardExpirationMonth },
      set (value) { this.updateCardExpirationMonth(value) }
    },
    cardExpirationYear: {
      get () { return this.$store.state.rechargeTagForm.cardExpirationYear },
      set (value) { this.updateCardExpirationYear(value) }
    },
    cardHolderFirstName: {
      get () { return this.$store.state.rechargeTagForm.cardHolderFirstName },
      set (value) { this.updateCardHolderFirstName(value) }
    },
    cardHolderLastName: {
      get () { return this.$store.state.rechargeTagForm.cardHolderLastName },
      set (value) { this.updateCardHolderLastName(value) }
    },
    cardHolderEmail: {
      get () { return this.$store.state.rechargeTagForm.cardHolderEmail },
      set (value) { this.updateCardHolderEmail(value) }
    },
    cardHolderStreet: {
      get () { return this.$store.state.rechargeTagForm.cardHolderStreet },
      set (value) { this.updateCardHolderStreet(value) }
    },
    cardHolderCity: {
      get () { return this.$store.state.rechargeTagForm.cardHolderCity },
      set (value) { this.updateCardHolderCity(value) }
    },
    cardHolderPhone: {
      get () { return this.$store.state.rechargeTagForm.cardHolderPhone },
      set (value) { this.updateCardHolderPhone(value) }
    },
    cardHolderZipCode: {
      get () { return this.$store.state.rechargeTagForm.cardHolderZipCode },
      set (value) { this.updateCardHolderZipCode(value) }
    },
    cardHolderState: {
      get () { return this.$store.state.rechargeTagForm.cardHolderState },
      set (value) { this.updateCardHolderState(value) }
    },
    cardHolderCountry: {
      get () { return this.$store.state.rechargeTagForm.cardHolderCountry },
      set (value) { this.updateCardHolderCountry(value) }
    },
    cardNumber: {
      get () { return this.$store.state.rechargeTagForm.cardNumber },
      set (value) { this.updateCardNumber(value) }
    },
    cardType: {
      get () { return this.$store.state.rechargeTagForm.cardType },
      set (value) { this.updateCardType(parseInt(value)) }
    },
    availableCardExpirationMonths () {
      const months = []

      for (let i = 1; i <= 12; i++) {
        const month = i.toLocaleString('en-US', { minimumIntegerDigits: 2 })

        months.push(month)
      }

      return months
    },
    availableCardExpirationYears () {
      const currentYear = new Date().getFullYear()
      const years = []

      for (let i = 0; i <= 10; i++) {
        years.push(currentYear + i)
      }

      return years
    },
    statesList () {
      return {
        MX: [
          { value: 'Aguascalientes', id: 'AG' },
          { value: 'Baja California', id: 'BC' },
          { value: 'Baja California Sur', id: 'BS' },
          { value: 'Campeche', id: 'CM' },
          { value: 'Chiapas', id: 'CS' },
          { value: 'Chihuahua', id: 'CH' },
          { value: 'Ciudad De México', id: 'CX' },
          { value: 'Coahuila', id: 'CO' },
          { value: 'Colima', id: 'CL' },
          { value: 'Durango', id: 'DG' },
          { value: 'Guanajuato', id: 'GT' },
          { value: 'Guerrero', id: 'GR' },
          { value: 'Hidalgo', id: 'HG' },
          { value: 'Jalisco', id: 'JC' },
          { value: 'Estado De México', id: 'EM' },
          { value: 'Michoacán', id: 'MI' },
          { value: 'Morelos', id: 'MO' },
          { value: 'Nayarit', id: 'NA' },
          { value: 'Nuevo León', id: 'NL' },
          { value: 'Oaxaca', id: 'OA' },
          { value: 'Puebla', id: 'PU' },
          { value: 'Querétaro', id: 'QT' },
          { value: 'Quintana Roo', id: 'QR' },
          { value: 'San Luis Potosí', id: 'SL' },
          { value: 'Sinaloa', id: 'SI' },
          { value: 'Sonora', id: 'SO' },
          { value: 'Tabasco', id: 'TB' },
          { value: 'Tamaulipas', id: 'TM' },
          { value: 'Tlaxcala', id: 'TL' },
          { value: 'Veracruz', id: 'VE' },
          { value: 'Yucatán', id: 'YU' },
          { value: 'Zacatecas', id: 'ZA' }
        ],
        US: [
          { value: 'Alabama', id: 'AL' },
          { value: 'Alaska', id: 'AK' },
          { value: 'Arizona', id: 'AZ' },
          { value: 'Arkansas', id: 'AR' },
          { value: 'California', id: 'CA' },
          { value: 'Colorado', id: 'CO' },
          { value: 'Connecticut', id: 'CT' },
          { value: 'Delaware', id: 'DE' },
          { value: 'Florida', id: 'FL' },
          { value: 'Georgia', id: 'GA' },
          { value: 'Hawaii', id: 'HI' },
          { value: 'Idaho', id: 'ID' },
          { value: 'Illinois', id: 'IL' },
          { value: 'Indiana', id: 'IN' },
          { value: 'Iowa', id: 'IA' },
          { value: 'Kansas', id: 'KS' },
          { value: 'Kentucky', id: 'KY' },
          { value: 'Louisiana', id: 'LA' },
          { value: 'Maine', id: 'ME' },
          { value: 'Maryland', id: 'MD' },
          { value: 'Massachusetts', id: 'MA' },
          { value: 'Michigan', id: 'MI' },
          { value: 'Minnesota', id: 'MN' },
          { value: 'Mississippi', id: 'MS' },
          { value: 'Missouri', id: 'MO' },
          { value: 'Montana', id: 'MT' },
          { value: 'Nebraska', id: 'NE' },
          { value: 'Nevada', id: 'NV' },
          { value: 'New Hampshire', id: 'NH' },
          { value: 'New Jersey', id: 'NJ' },
          { value: 'New Mexico', id: 'NM' },
          { value: 'New York', id: 'NY' },
          { value: 'North Carolina', id: 'NC' },
          { value: 'North Dakota', id: 'ND' },
          { value: 'Ohio', id: 'OH' },
          { value: 'Oklahoma', id: 'OK' },
          { value: 'Oregon', id: 'OR' },
          { value: 'Pennsylvania', id: 'PA' },
          { value: 'Rhode Island', id: 'RI' },
          { value: 'South Carolina', id: 'SC' },
          { value: 'South Dakota', id: 'SD' },
          { value: 'Tennessee', id: 'TN' },
          { value: 'Texas', id: 'TX' },
          { value: 'Utah', id: 'UT' },
          { value: 'Vermont', id: 'VT' },
          { value: 'Virginia', id: 'VA' },
          { value: 'Washington', id: 'WA' },
          { value: 'West Virginia', id: 'WV' },
          { value: 'Wisconsin', id: 'WI' },
          { value: 'Wyoming', id: 'WY' }
        ]
      }[this.cardHolderCountry]
    },
    dataReady: function () {
      return !this.isLoading && !this.balanceIsLoading
    },
    banorteValidatorPath: function () {
      return process.env.VUE_APP_BANORTE_3DSECURE2_URL
    },
    forwardPath: function () {
      return `${process.env.VUE_APP_BANORTE_FORWARDPATH}/guest`
    },
    canProcess: function () {
      return true
    }
  },
  watch: {
    tagNotFound (newValue, _) {
      if (newValue === true) {
        this.errors = {
          ...this.errors,
          tag: [
            `El TAG ${this.tag} no se encuentra registrado`
          ]
        }
      } else {
        this.errors = {}
      }
    },
    tag (newValue, oldValue) {
      if (newValue.length >= 14) {
        return this.getBalance()
      }
      if (oldValue.length >= 14 && newValue.length < 14) {
        return this.resetBalance()
      }
    },
    cardNumber (newValue, oldValue) {
      if (newValue.length >= 14) {
        return this.getCommission()
      }

      if (oldValue.length >= 14 && newValue.length < 14) {
        return this.resetCommission()
      }
    }
  },
  methods: {
    ...mapActions('app', [
      'startLoading',
      'finishLoading'
    ]),
    ...mapActions('guestCreatedSaleOrder', [
      'createTagSaleOrder'
    ]),
    ...mapActions('rechargeTagForm', [
      'getCommission',
      'resetCommission',
      'updateTag',
      'updateAmount',
      'updateCardExpirationMonth',
      'updateCardExpirationYear',
      'updateCardHolderFirstName',
      'updateCardHolderLastName',
      'updateCardHolderEmail',
      'updateCardHolderPhone',
      'updateCardHolderStreet',
      'updateCardHolderZipCode',
      'updateCardHolderCountry',
      'updateCardHolderState',
      'updateCardHolderCity',
      'updateCardNumber',
      'updateCardType',
      'getBalance',
      'resetBalance'
    ]),
    clearErrors () {
      this.errors = {}
    },
    openInformationModal () {
      this.isInformationModalActive = true
    },
    closeInformationModal () {
      this.submitForm()
    },
    async submitForm () {
      await this.createTagSaleOrder()

      if (this.saleOrderTotal && this.saleOrderId) {
        const result = await this.getBalance()
        if (result) {
          this.$refs.form.submit()
        } else {
          this.resetBalance()
          this.tag = ''
          this.isInformationModalActive = false
          alert('Lamentamos el inconveniente, es necesario volver a introducir su TAG.')
        }
      }
    },
    validateForm () {
      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() + 1

      this.clearErrors()
      if (!this.tag || this.tag.length < 14 || this.loadedAndWrong || this.tagNotFound) {
        this.errors = {
          ...this.errors,
          tag: [
            'Debes introducir un TAG válido'
          ]
        }
      }
      if (this.amount <= 0 || isNaN(this.amount)) {
        this.errors = {
          ...this.errors,
          amount: [
            'Debes introducir la cantidad que deseas recargar'
          ]
        }
      } else {
        if (this.amount < 36.0) {
          this.errors = {
            ...this.errors,
            amount: [
              'La recarga mínima es de $36 MXN'
            ]
          }
        }
      }
      if (!this.cardNumber || this.cardNumber.length < 16) {
        this.errors = {
          ...this.errors,
          cardNumber: [
            'Debes introducir un número de tarjeta válido'
          ]
        }
      }
      if (!this.cardHolderFirstName) {
        this.errors = {
          ...this.errors,
          cardHolderFirstName: [
            'Debes introducir el nombre de la tarjeta'
          ]
        }
      }
      if (!this.cardHolderLastName) {
        this.errors = {
          ...this.errors,
          cardHolderLastName: [
            'Debes introducir los apellidos de la tarjeta'
          ]
        }
      }
      if (!this.cardExpirationMonth || !this.cardExpirationYear || (parseInt(this.cardExpirationYear) === currentYear && parseInt(this.cardExpirationMonth) <= currentMonth)) {
        this.errors = {
          ...this.errors,
          cardExpirationDate: [
            'Debes introducir una fecha de expiración válida para la tarjeta'
          ]
        }
      }
      if (!this.cardHolderState) {
        this.errors = {
          ...this.errors,
          cardHolderState: [
            'Debes seleccionar un Estado'
          ]
        }
      }
      if (!this.cardHolderEmail) {
        this.errors = {
          ...this.errors,
          cardHolderEmail: [
            'Debes introducir un correo electronico'
          ]
        }
      }
      if (!this.cardHolderPhone) {
        this.errors = {
          ...this.errors,
          cardHolderPhone: [
            'Debes introducir un número de teléfono'
          ]
        }
      }
      if (!this.cardHolderStreet) {
        this.errors = {
          ...this.errors,
          cardHolderStreet: [
            'Debes introducir tu calle'
          ]
        }
      }
      if (!this.cardHolderCity) {
        this.errors = {
          ...this.errors,
          cardHolderCity: [
            'Debes introducir tu ciudad'
          ]
        }
      }
      if (!this.cardHolderZipCode) {
        this.errors = {
          ...this.errors,
          cardHolderZipCode: [
            'Debes introducir tu código postal'
          ]
        }
      }
      if (!this.cardHolderCountry) {
        this.errors = {
          ...this.errors,
          cardHolderCountry: [
            'Debes introducir tu país'
          ]
        }
      }
      if (!this.cardHolderState) {
        this.errors = {
          ...this.errors,
          cardHolderState: [
            'Debes introducir tu estado'
          ]
        }
      }

      if (Object.keys(this.errors).length === 0) { // no errors but ...
        this.openInformationModal()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';
input, label, select {
  font-size: 1.2rem;
  min-width: 50%;
  text-align: left;
}
.fake-input {
  font-size: 1.2rem;
  min-width: 50%;
  text-align: left;
  select {
    min-width: 40%;
  }
}
.form-group {
  margin: 0.5rem 0;
}

.errors {
  color: $red;
  font-size: 1rem;
  margin-top: -0.5rem;
  margin-bottom: 1rem;
  text-align: right;
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.short-input {
  width: 4rem;

  &:nth-child(1) {
    margin-right: 0.5rem;
  }
  &:nth-child(3) {
    margin-left: 0.5rem;
  }
}
fieldset {
  display: none;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
input[type=radio] {
    border: 0px;
    min-width: 20px;
}
input[data-valid="true"] {
  border-bottom-color: green;
  border-bottom-width: 5px;
}
input[data-invalid="true"] {
  border-bottom-color: red;
  border-bottom-width: 5px;
}
@media screen and (max-width: 960px) {
  button.btn {
    font-size: 1.2rem;
    width: 80%;
  }
  .flex.form-group {
    flex-direction: column;
    text-align: left;
    margin-bottom: 1rem;
  }
  .flex.form-group.rad {
    flex-direction: row;
  }
  p.summary {
    padding-right: 1em;
  }
  .form-group {
    label, input, select {
      width: 100%;
    }
  }
  .flex.form-group.fake-input{
    flex-direction: row;
    select {
      min-width: 40%;
      width: 40%;
    }
  }
  input[type=radio] {
    border: 0px;
    min-height: 20px;
  }
}
</style>
